import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Typography, ListItem, Box, Divider } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const useStyles = makeStyles(() => ({
  media: {
    width: 200,
  },
  chip: {
    color: 'white',
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  strike: {
    textDecoration: 'line-through',
    color: '#8a8a8a',
  },
  alignLeft: {
    textAlign: 'left',
  },
  alignCenter: {
    textAlign: 'center',
  },
  orangeColor: {
    backgroundColor: '#F07C17',
  },
  lightGreenColor: {
    backgroundColor: '#3FD678',
  },
  starColor: {
    color: '#698CFF',
  },
  upperCase: {
    textTransform: 'uppercase',
  },
  cardListItem: {
    border: '1px solid #e6e6e6e8',
    borderRadius: '10px',
    backgroundColor: 'white',
    marginBottom: 16,
  },
}));

function SchoolItemSkeletonComponent(props) {
  const classes = useStyles();
  const { repeat } = props;

  const getSkeletons = () => {
    const skeletons = [];

    for (let i = 0; i < repeat; i++) {
      skeletons.push(
        <ListItem key={i} className={classes.cardListItem}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Box height="100%" display="flex" alignItems="center">
                <Skeleton variant="rectangular" width="100%" height={140} />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography color="textPrimary" align="left" variant="h5">
                <Box display="inline" fontWeight={500}>
                  <Skeleton variant="text" />
                </Box>
              </Typography>
              <Typography
                display="inline"
                color="textPrimary"
                align="left"
                variant="subtitle1"
              >
                <Skeleton variant="text" width="80%" />
              </Typography>
              <Box component="div" display="block" mt={1} mb={1}>
                <Box component="div" display="inline">
                  <Skeleton variant="text" width="70%" />
                </Box>
              </Box>
              <Divider />
              <Box mt={1} className={classes.alignLeft}>
                <Typography
                  className={classes.upperCase}
                  display="inline"
                  color="textPrimary"
                  align="left"
                  variant="caption"
                >
                  <Box display="inline" fontWeight={500} letterSpacing={1}>
                    <Skeleton variant="text" width="100%" />
                  </Box>
                </Typography>
              </Box>
              <Box className={classes.alignLeft}>
                <Typography
                  className={classes.upperCase}
                  display="inline"
                  color="textPrimary"
                  align="left"
                  variant="caption"
                >
                  <Box display="inline" fontWeight={500} letterSpacing={1}>
                    <Skeleton variant="text" width="100%" />
                  </Box>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={3} className={classes.alignCenter}>
              <Box m={1}>
                <Skeleton variant="rectangular" width="100%" height={90} />
              </Box>
              <Box m={1}>
                <Skeleton variant="rectangular" width="100%" height={30} />
              </Box>
            </Grid>
          </Grid>
        </ListItem>
      );
    }

    return skeletons;
  };

  return getSkeletons().map((skeleton) => skeleton);
}

export default SchoolItemSkeletonComponent;

SchoolItemSkeletonComponent.propTypes = {
  repeat: PropTypes.number,
};

SchoolItemSkeletonComponent.defaultProps = {
  repeat: 1,
};
